<script>
import { BModal } from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import dateRenderer from "@core/mixins/date-renderer";
import {RequestStatus} from "@/libs/product";

export default {
    mixins: [dateRenderer],
    components: {AppTimeline, AppTimelineItem, BModal},
    props: {
        lifeCycle: {
            required: true
        },
        title: {
            type: String,
            default: null,
        },
    },
    computed: {
        modalTitle() {
            return this.title || this.$t('Component(RequestLifeCycle):label')
        }
    },
    methods: {
        show() {
            this.$refs.lifeCycle.show();
        },
        resolveVariant(record) {
            if (record.status.id === RequestStatus.APPROVED || record.status.id === RequestStatus.PARTIALLY_APPROVED) {
                return 'primary'
            }
            if (record.status.id === RequestStatus.REPLIED) {
                return 'success';
            }
            if (record.status.id === RequestStatus.REJECTED) {
                return 'danger';
            }
            return 'secondary';
        }
    }
}
</script>

<template>
    <b-modal
        ref="lifeCycle"
        cancel-variant="outline-secondary"
        :ok-title="$t('Component(Button):close')"
        ok-only
        centered
        :title="modalTitle"
    >
        <app-timeline>
            <app-timeline-item
                v-for="record in lifeCycle"
                :title="record.status.title"
                :subtitle="record.user"
                :time="renderDateTime(record.setAt)"
                :variant="resolveVariant(record)"
            />
        </app-timeline>
    </b-modal>
</template>
